import { Action } from '@ngrx/store';
import { ServiceGroup } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len

export const ADD_PENDING_ACCEPTED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Add Pending Accepted Service In State';
export class AddPendingAcceptedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = ADD_PENDING_ACCEPTED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { serviceGroup: any }) {}
}

export const REMOVE_PENDING_ACCEPTED_SERVICE_IN_STATE =
  '[VEHICLE_MAINTENANCE] Remove Pending Accepted Service In State';
export class RemovePendingAcceptedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = REMOVE_PENDING_ACCEPTED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: string }) {}
}

export const CLEAR_PENDING_ACCEPTED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Pending Accepted Service In State';
export class ClearPendingAcceptedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_PENDING_ACCEPTED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type PendingAcceptedServiceAction =
  | AddPendingAcceptedServiceInState
  | RemovePendingAcceptedServiceInState
  | ClearPendingAcceptedServiceInState;
